import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/app/App'
import { RootStore, StoreProvider } from '@/stores/RootStore'
import '@/app/styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('В index.html нет узла #root')

// Один экземпляр на приложение. Создаётся здесь, а не внутри App:
// в StrictMode компонент монтируется дважды, и стор, созданный там,
// пересоздался бы вместе с ним — вместе с уже загруженными данными.
const store = new RootStore()

createRoot(root).render(
  <StrictMode>
    <StoreProvider value={store}>
      <App />
    </StoreProvider>
  </StrictMode>,
)
